import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "reports-service/v1/cms/reports/srp";

export default {
    getList: async function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/list/" + param.page,
                param.param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    exportXls: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/export", param, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    exportPdf: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/exportPDF", param, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },

    importSrp: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/import", param, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },

    getFilters: async function() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/filters",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    
    getYears: function() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/year",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
}